import * as yup from 'yup';
import { FIELDS } from 'modules/cm/domain/Case/Applicant/Income/Future/Future';
import { nullableNumber, nullableString } from 'utils/form/validation';
import { FormModel } from './types';

const messages = {
  required: 'This field is required',
};

export default yup.object().shape<FormModel>({
  [FIELDS.MINIMUM_RETIRED_INCOME]: nullableNumber(),
  [FIELDS.FUTURE_INCOME_TOTAL]: nullableNumber(),
  [FIELDS.EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME]: nullableNumber(),
  [FIELDS.EMPLOYED_ANTICIPATED_RETIREMENT_DATE]: nullableString(),
  [FIELDS.SELF_EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME]: nullableNumber(),
  [FIELDS.SELF_EMPLOYED_ANTICIPATED_RETIREMENT_DATE]: nullableString(),
  [FIELDS.MINIMUM_TAXABLE_RETIRED_INCOME]: nullableNumber().required(messages.required),
  [FIELDS.HAS_TAXABLE_RETIRED_INCOME_CONTINUING]: yup.boolean().nullable(),
  [FIELDS.MINIMUM_TAX_FREE_RETIRED_INCOME]: nullableNumber().required(messages.required),
  [FIELDS.HAS_TAX_FREE_RETIRED_INCOME_CONTINUING]: yup.boolean().nullable(),
  [FIELDS.OTHER_INCOME_ANTICIPATED_GROSS_ANNUAL_INCOME]: nullableNumber(),
  [FIELDS.OTHER_INCOME_DETAILS]: nullableString(),
  [FIELDS.MINIMUM_TAXABLE_RETIRED_INCOME_DETAILS]: nullableString(),
  [FIELDS.MINIMUM_TAX_FREE_RETIRED_INCOME_DETAILS]: nullableString(),
  [FIELDS.FUTURE_INCOME_PENSION]: nullableNumber(),
});
